<template>
  <!-- https://www.rhenopalatia.com/%C3%BCber-uns/faq/ -->
  <!-- https://albertina.de/faq -->

  <!-- https://bootstrap-vue.js.org/docs/components/collapse -->

  <div role="tablist" style="margin-top: 3rem;">

  <!-- https://unsplash.com/photos/yjePAp-tpmQ -->
    <div>
      <b-img src="/public/downloads/directories/images/faq.jpg" fluid alt="FAQ"></b-img>
    </div>
    <br/>
    <br/>
    <p>
    In diesem Bereich möchten wir uns kurz mit den häufigsten an uns gerichteten Fragen oder Meinungen auseinandersetzen.
    Die Antworten sollen keinesfalls den persönlichen Diskurs ersetzen, sondern lediglich dem unvoreingenommenen Besucher
    eine Vorstellung vermitteln, in welchem Spannungsfeld der Meinungen sich das heutige Verbindungsleben befindet. Zu einem
    weiterergehenden Gespräch stehen wir natürlich jederzeit gerne zur Verfügung.
    </p>
    <br/>
    <br/>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-1 variant="primary">Warum nehmt Ihr keine Frauen auf?</b-button>
      </b-card-header>
      <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
          <!-- 1902	Beginn der Koedukation mit der Aufnahme einer Schülerin in die Sexta -->
          Das liegt in unserer Tradition begründet. Unsere Verbindung existiert bereits seit 1895 und wurde von Schülern des Schönborn Gymnasiums gegründet.
          Bis 1902 war diese Schule eine reine Jungenschule. So kam man damals wahrscheinlich gar nicht auf die Idee, auch Frauen aufzunehmen.
          Dennoch sind Damen bei vielen Veranstaltungen herzlich willkommen und gern gesehene Gäste.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-2 variant="primary">Seid Ihr rechts(radikal)?</b-button>
      </b-card-header>
      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
          Nein! Hier wollen wir auf den Artikel 2 unserer Verfassung hinweisen, in dem es heisst, dass politische oder religiöse
          Bestrebungen keine Rolle spielen dürfen.
          Und auch bei der Aufnahme spielen Religion, Parteibuch oder Herkunft keine Rolle.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-3 variant="primary">Ihr sauft doch nur, oder?</b-button>
      </b-card-header>
      <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
          Ein klares 'Jein'. Gerade die Jüngeren würden die Frage wahrscheinlich grinsend bejahren. Aber die älteren Semster, die am nächsten Morgen vom Nachwuchs
          aus dem Bett getrieben werden, halten sich spürbar zurück. Und wer fährt, trinkt selbstverständlich nicht.
          Wir passen aufeinander auf und sorgen dafür, dass jeder heil nach Hause kommt. Und da unser Standardgetränk das gute Pils ist, hält sich der Kater am nächsten Morgen meist auch
          in Grenzen. Harter Alkohol ist bei uns verpönt.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-4 variant="primary">Gibt es bei Euch einen Trinkzwang?</b-button>
      </b-card-header>
      <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
           Quatsch! Bei uns trinkt jeder nur, soviel er will. Gezwungen wird keiner. Es gibt auch keine Erwartungshaltung oder Gruppenzwang.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-5 variant="primary">Bleibt mir noch Zeit für die Schule bzw. mein Studium?</b-button>
      </b-card-header>
      <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
          Klar. Selbst wenn man sich dazu entschlossen hat, ein Amt zu übernehmen, bleibt der dazu notwenige Zeitaufwand in einem sehr überschaubaren Rahmen.
          Veranstaltungen sind im Schnitt nur einmal im Monat, so dass es kein Problem darstellen sollte, Schule, die Verbindung und etwaige andere Aktivitäten unter einen Hut zu bekommen.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-6 variant="primary">Wer kann in die Verbindung eintreten?</b-button>
      </b-card-header>
      <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
           Generell gilt: Jeder Schüler eines der Bruchsaler Gymnasien ab der 9. Klasse bzw. ab 16 Jahren. Wie immer gilt: Ausnahmen bestätigen die Regel.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-7 variant="primary">Wo und wie findet man uns?</b-button>
      </b-card-header>
      <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            Wer Interesse hat uns kennenzulernen, schreibt am besten eine kurze Mail an <a href="mailto:info@pv-bund.de">info@pv-bund.de</a>.
            Wir treffen uns etwa einmal im Monat und begrüßen immer gerne interessierte Gäste. Bei den meisten Veranstaltungen sind auch Frauen herzlich willkommen.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        text: `
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
          richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
          brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
          tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
          assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
          wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
          vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
          synth nesciunt you probably haven't heard of them accusamus labore VHS.
        `
      }
    }
  }
</script>